module.exports = __webpack_public_path__ + "img/50_31.9270dcaf.png";